import { QuestionBase } from './question-base';

export class TitleQuestion extends QuestionBase<string> {
  controlType = 'title';
}
